import React, { createContext } from 'react';
import Loading from '../Components/Loading';

import AuthProviderHook from '../hooks/AuthProvider';


export const Context = createContext();

export const AuthProvider = ({ children }) => {
    const  {
        handleLogin,
        handleLogout,
        user,
        auth,
        loading,
        setUserSession,
    } = AuthProviderHook();

    if (loading) {
        return (
            <Context.Provider>
                <Loading label="Verficando a disponibilidade com o servidor" full={true} />
            </Context.Provider>
        )
    }

    return (
        <Context.Provider
            value={{
                isAuth: auth,
                user,
                handleLogin,
                handleLogout,
                setUserSession,

            }}
        >
            {children}
        </Context.Provider>
    )
}

